import React, { useContext } from 'react';
import { fittingRecommendationsContext } from '../../context/fittingRecommendationsContext';
import { LocalizationContext } from '../../context/localizationContext';
import Styles from './MyFittingProfile.module.scss';

const MyFittingProfile = () => {
  const { state } = useContext(fittingRecommendationsContext);
  const { fittingRecommendations, fullBagJson } = state;
  const { localizationState } = useContext(LocalizationContext);
  const { localization } = localizationState;
  const golferProfileMap = {
    gender: 'Gender',
    dexterity: 'Dexterity',
    heightInInches: 'Height',
    handicap: 'Handicap',
    sevenIronCarryDistanceInYards: '7-Iron Carry Distance',
    handSize: 'Hand Measurement',
    wristToFloorInInches: 'Wrist-to-Floor Measurement',
  };

  const colorMap = {
    gold: '#FDB727',
    green: '#009D57',
    silver: '#B1B3B6',
    maroon: '#A2224C',
    red: '#EE3524',
    black: '#000000',
    pink: '#EC7DB0',
    orange: '#F47920',
    purple: '#46499E',
    brown: '#744739',
    white: '#FFFFFF',
    blue: '#00AEEF',
    yellow: '#FFE100',
  };

  const getPingColorCode = () => {
    const ironRecommendation = fittingRecommendations.find(
      (rec) => rec.type === 'iron',
    );
    if (ironRecommendation?.colorCodeColorOnly) {
      return (
        <>
          <div className={Styles.colorCodeDotWrapper}>
            <span
              className={Styles.colorCodeDot}
              style={{
                background:
                  colorMap[
                    ironRecommendation?.colorCodeColorOnly?.toLowerCase()
                  ],
              }}
            ></span>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: `${localization?.fittingProfile.colorCodeMessage} ${ironRecommendation.colorCode}`,
            }}
          />
        </>
      );
    }

    return '';
  };

  return (
    <div className={Styles.myFittingProfile}>
      <div className={Styles.header}>
        {state.userProfile && (
          <div>
            <span className={Styles.avatar}>
              {state.userProfile.FullName?.charAt(0)}
              {state.userProfile.LastName?.charAt(0)}
            </span>
          </div>
        )}
        <span className={Styles.headerInfo}>
          <div className={Styles.name}>{state.userProfile.FullName}</div>
          <span className={Styles.colorCodeWrapper}>{getPingColorCode()}</span>
        </span>
      </div>
      <div className={Styles.golferInfo}>
        {Object.entries(golferProfileMap).map(([key, value]) => {
          const golferValue = fullBagJson?.golferProfile[key];
          if (golferValue) {
            return (
              <div className={Styles.golferInfoItem}>
                <div className={Styles.golferInfoLabel}>{value}</div>
                <div className={Styles.golferInfoValue}>
                  {typeof fullBagJson?.golferProfile[key] === 'string'
                    ? `${fullBagJson?.golferProfile[key]
                      ?.charAt(0)
                      .toUpperCase()}${golferValue?.slice(1)}`
                    : golferValue}
                </div>
              </div>
            );
          }
          return '';
        })}
      </div>
    </div>
  );
};

export default MyFittingProfile;
